var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.student
    ? _c(
        "div",
        { staticClass: "student-card py-3 px-4" },
        [
          _vm.$mq !== "mobile"
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Name:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.studentName))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Student ID:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.studentExtId))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Birth Date:")])]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(_vm.student.birthDate))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Gender:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.gender))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Grade:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.grade))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("School Name:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.schoolName))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Service Type:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.serviceName))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Frequency:")])]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.student.frequency))])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("ESY:")])]),
                    _vm._v(" "),
                    _c("div", [
                      _vm.student.esy
                        ? _c("span", [_vm._v("YES")])
                        : _c("span", [_vm._v("NO")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [
                      _c("strong", [_vm._v("Projected Start Date:")])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(_vm.student.startDate))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm4: "", md3: "", "py-1": "" } }, [
                    _c("div", [_c("strong", [_vm._v("Projected End Date:")])]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("formatDate")(_vm.student.endDate)))
                    ])
                  ])
                ],
                1
              )
            : [
                _c("div", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.student.studentName) +
                        " (" +
                        _vm._s(_vm.student.studentExtId) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.student.schoolName))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pr-3" }, [
                    _vm._v("Gr: " + _vm._s(_vm.student.grade))
                  ]),
                  _vm._v(
                    "\n      " + _vm._s(_vm.student.serviceName) + "\n    "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDate")(_vm.student.startDate)) +
                        " - " +
                        _vm._s(_vm._f("formatDate")(_vm.student.endDate)) +
                        "\n      "
                    )
                  ]),
                  _vm._v("\n      ESY:\n      "),
                  _vm.student.esy
                    ? _c("span", [_vm._v("YES")])
                    : _c("span", [_vm._v("NO")])
                ])
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0502e6ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0502e6ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/student-card.vue
// module id = null
// module chunks = 